import { render, staticRenderFns } from "./FormInputStandardUserReceiveMessagesFunction.vue?vue&type=template&id=0fd76e98&scoped=true&lang=pug"
import script from "./FormInputStandardUserReceiveMessagesFunction.vue?vue&type=script&lang=ts"
export * from "./FormInputStandardUserReceiveMessagesFunction.vue?vue&type=script&lang=ts"
import style0 from "./FormInputStandardUserReceiveMessagesFunction.vue?vue&type=style&index=0&id=0fd76e98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd76e98",
  null
  
)

export default component.exports